import { APP_ENV } from './consts';

export default (function Logo() {
    switch (APP_ENV) {
        case 'sabol':
            return '/chate-horizontal.png';
        case 'puppet-interview':
            return '/puppet_interview_logo.png';
        case 'crest':
            return '/CREST-logo.png';
        default:
            return '';
    }
})();
